import {SET_FAVORITES,
        CHECK_FAVORITE_OFFER, DELETE_FAVORITE_OFFERS,
        CHECK_ALL_FAVORITE_OFFERS} from '../constants/favorites';
import favoritesAPI from '../../_api/favorites';
import cartAPI from '../../_api/cart';
import shopAPI from '../../_api/shop';
import {decrementFavoritesCount, incrementCartCount} from './auth';


const setFavoriteOffers = (count, list) => ({type: SET_FAVORITES, count, list});
export const checkFavoriteOffer = id => ({type: CHECK_FAVORITE_OFFER, id});
const removeFavoriteOffers = ids => ({type: DELETE_FAVORITE_OFFERS, ids});
export const checkAllFavoriteOffers = is_checked => ({type: CHECK_ALL_FAVORITE_OFFERS, is_checked});

export const getFavoritesOffers = (page) => async (dispatch) => {
  const response = await favoritesAPI.getList(page);
  if (response) dispatch(setFavoriteOffers(response.count, response.results));
};

export const deleteFavoriteOffers = (ids) => async (dispatch) => {
  const response = await favoritesAPI.deleteList(ids);
  if (response){
    dispatch(removeFavoriteOffers(ids));
    dispatch(decrementFavoritesCount(ids.length));
  }
};

export const addToCartFavoriteOffers = (ids) => async (dispatch) => {
  // добавление выбранных аранжировок в корзину
  // 1. добавляем в корзину
  let response = await cartAPI.addOffersToCart(ids);
  if (response) {
    // response.data.invalid - невалидные или те которые уже в корзине
    // 2. увеличиваем кол-во в корзине
    dispatch(incrementCartCount(ids.length - response.invalid.length));
    // // 3. передаем данные в аналитику - GuitarOnly
    // if (!window.debug){
    //   if (response.analitics.length){
    //     // для гугла - GuitarOnly
    //     let products = [];
    //     let transactionTotal = 0;
    //     for (let i of response.analitics){
    //       let price = parseFloat(i.offer_price.replace(",","."));
    //       products.push({
    //         'id': i.offer_id,
    //         'name': i.offer_name,
    //         'price': price,
    //         'brand': i.offer_brand,
    //         'quantity': 1
    //       });
    //       transactionTotal = transactionTotal + price;
    //     }
    //     dataLayer.push({
    //       'event': 'addToCard',
    //       'currencyCode': response.analitics[0].offer_currency, // data for facebook pixel
    //       'transactionTotal': transactionTotal, // data for facebook pixel
    //       'ecommerce': {
    //         'currencyCode': response.analitics[0].offer_currency,
    //         'add': {
    //           'products': products
    //         }
    //       }
    //     });
    //   }
    // }
    return true;
  }
};

export const buyFavoriteOffer = (id, payload) => async (dispatch) => {
  // покупка аранжировки из Избранного
  // 1. отправляем пост запрос на урл покупки аранжировки
  try{
    let response = await shopAPI.buyOffer(id, payload);
    if (response){
      // 2. передаем данные в метрику
      // if (yandexMetrica && !window.debug){
      //   ym(yandexMetrica, 'reachGoal', 'GO-TO-PAY-ONE-CLICK');
      // }
      // 3 переходим на страницу оплаты
      document.location = response.redirect_url;
    }
  } catch (e) {
    return { error: e.message }
  }
};
